var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "parametric-openfilter",
      on: {
        click: function($event) {
          return _vm.isFilterOpen()
        }
      }
    },
    [
      _c(
        "svg",
        {
          attrs: {
            width: "19",
            height: "18",
            viewBox: "0 0 19 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M2 4.5L12.5 4.5M12.5 4.5C12.5 5.74264 13.5074 6.75 14.75 6.75C15.9926\n        6.75 17 5.74264 17 4.5C17 3.25736 15.9926 2.25 14.75 2.25C13.5074 2.25 12.5 3.25736\n        12.5 4.5ZM6.5 13.5L17 13.5M6.5 13.5C6.5 14.7426 5.49264 15.75 4.25 15.75C3.00736\n        15.75 2 14.7426 2 13.5C2 12.2574 3.00736 11.25 4.25\n        11.25C5.49264 11.25 6.5 12.2574 6.5 13.5Z",
              stroke: "#002F4A",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }
          })
        ]
      ),
      _vm._v("\n\n    Фильтр\n")
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }